<template>
  <div>
    <div class="swiper-container swiper-container-v content1">
      <header class="header">
        <div class="top-nav">
          <img
            src="../../assets/picture/199.png"
            style="margin-top: 20px"
            alt="哈哈享租"
          />
          <!-- <span>只为使用付费 不为残值买单</span> -->
          <ul>
            <li><a href="" id="active">首页</a></li>
            <!-- <li><a href="event.html">重大事件</a></li>
            <li><a href="guarantee.html">安全保障</a></li>
            <li><a href="about.html">关于我们</a></li> -->
          </ul>
        </div>
      </header>
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="first">
            <div class="table-box">
              <div class="table-cell">
                <div class="content">
                  <img
                    class="tupian ani"
                    swiper-animate-effect="fadeInUp"
                    swiper-animate-duration="0.7s"
                    swiper-animate-delay="0.3s"
                    src="../../assets/picture/jiuaishua2.png"
                    alt=""
                  />
                  <!-- <span
                    class="tips ani"
                    swiper-animate-effect="fadeInUp"
                    swiper-animate-duration="0.7s"
                    swiper-animate-delay="0.6s"
                    >只为使用付费 不为残值买单</span
                  > -->
                  <i
                    class="ani"
                    swiper-animate-effect="fadeInUp"
                    swiper-animate-duration="0.7s"
                    swiper-animate-delay="0.9s"
                  >
                  </i>
                  <img
                    class="erweima ani"
                    swiper-animate-effect="fadeIn"
                    swiper-animate-duration="0.4s"
                    swiper-animate-delay="1s"
                    src="../../assets/picture/21.png"
                    alt=""
                  />
                  <!-- <p
                    class="ani"
                    swiper-animate-effect="fadeIn"
                    swiper-animate-duration="0.5s"
                    swiper-animate-delay="1.2s"
                  >
                    下载APP&nbsp; 用机体验更好
                  </p> -->
                  <img
                    src="../../assets/picture/67.png"
                    alt=""
                    style="width: 377px; height: 300px"
                    class="renwu"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="fource">
            <div class="table-box">
              <div class="table-cell">
                <div class="fource-content">
                  <p class="fource-title">简单用机</p>
                  <span class="fource-tips">只需4步 立即拥有</span>
                </div>
                <div class="fource-explain">
                  <div class="explain-one fl">
                    <p
                      class="ani"
                      swiper-animate-effect="fadeInUp"
                      swiper-animate-duration=".4s"
                      swiper-animate-delay="0s"
                    >
                      挑选机型
                    </p>
                    <span
                      class="ani"
                      swiper-animate-effect="fadeIn"
                      swiper-animate-duration=".4s"
                      swiper-animate-delay="0.2s"
                      >如：选择iPhone 15 Pro MAX 暗夜紫
                      256G，不同机型可选不同使用时长，3、6、12个月任您选</span
                    >
                  </div>
                  <div class="line fl"></div>
                  <div class="explain-two fl">
                    <p
                      class="ani"
                      swiper-animate-effect="fadeInUp"
                      swiper-animate-duration=".4s"
                      swiper-animate-delay="0.2s"
                    >
                      押金0支付
                    </p>
                    <span
                      class="ani"
                      swiper-animate-effect="fadeIn"
                      swiper-animate-duration=".4s"
                      swiper-animate-delay="0.4s"
                      >无需立即支付现金，冻结额度做押金；冻结额度不产生费用、无需还款、随还机释放。</span
                    >
                  </div>
                  <div class="line fl"></div>
                  <div class="explain-three fl">
                    <p
                      class="ani"
                      swiper-animate-effect="fadeInUp"
                      swiper-animate-duration=".4s"
                      swiper-animate-delay="0.4s"
                    >
                      月付服务费
                    </p>
                    <span
                      class="ani"
                      swiper-animate-effect="fadeIn"
                      swiper-animate-duration=".4s"
                      swiper-animate-delay="0.6s"
                      >签订代扣协议，每月自动从支付宝中扣除服务费</span
                    >
                  </div>
                  <div class="line fl"></div>
                  <div class="explain-four fl">
                    <p
                      class="ani"
                      swiper-animate-effect="fadeInUp"
                      swiper-animate-duration=".4s"
                      swiper-animate-delay="0.6s"
                    >
                      预约新机 退还旧机
                    </p>
                    <span
                      class="ani"
                      swiper-animate-effect="fadeIn"
                      swiper-animate-duration=".4s"
                      swiper-animate-delay="0.8s"
                      >归还：支持门店或邮寄归还；<br />
                      续期：申请续期，可继续使用机器;<br />
                      买断：支付机器尾款，终身拥有</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="third">
            <div class="table-box">
              <div class="table-cell">
                <div class="third-content">
                  <p class="third-title">聪明消费</p>
                  <span class="third-tips">物超所值</span>
                  <div class="third-show">
                    <div class="fenqi fl">
                      <a href="#">
                        <div class="box"></div>

                        <p class="show-tips">
                          每月只需支付一百元起，即可轻松用上iPhone、华为等热门手机
                        </p>
                      </a>
                      <p
                        class="ani"
                        swiper-animate-effect="fadeInUp"
                        swiper-animate-duration="0.4s"
                        swiper-animate-delay="0s"
                      >
                        分期用
                      </p>
                      <span
                        class="ani"
                        swiper-animate-effect="fadeInUp"
                        swiper-animate-duration="0.4s"
                        swiper-animate-delay="0.1s"
                        >每期付费 最低3元/天</span
                      >
                    </div>
                    <div class="qingsong fl">
                      <a href="#">
                        <div class="box"></div>

                        <p class="show-tips">
                          携手芝麻信用，为信用好的用户实现0元押金用机
                        </p>
                      </a>
                      <p
                        class="ani"
                        swiper-animate-effect="fadeInUp"
                        swiper-animate-duration="0.4s"
                        swiper-animate-delay="0.2s"
                      >
                        轻松用
                      </p>
                      <span
                        class="ani"
                        swiper-animate-effect="fadeInUp"
                        swiper-animate-duration="0.4s"
                        swiper-animate-delay="0.4s"
                        >信用好可全免押金</span
                      >
                    </div>
                    <div class="anxin fl">
                      <a href="#">
                        <div class="box"></div>

                        <p class="show-tips">
                          配套意外保障服务，使用期间机器出现问题可免费维修
                        </p>
                      </a>
                      <p
                        class="ani"
                        swiper-animate-effect="fadeInUp"
                        swiper-animate-duration="0.4s"
                        swiper-animate-delay="0.4s"
                      >
                        安心用
                      </p>
                      <span
                        class="ani"
                        swiper-animate-effect="fadeInUp"
                        swiper-animate-duration="0.4s"
                        swiper-animate-delay="0.6s"
                        >免费维修服务 用机有保障</span
                      >
                    </div>
                    <div class="linhuo fl">
                      <a href="#">
                        <div class="box"></div>

                        <p class="show-tips">
                          还机：再次下单 立享新机 退还旧机<br />
                          买断：支付机器尾款，终身拥有<br />
                          续期：申请续期，可继续使用机器
                        </p>
                      </a>
                      <p
                        class="ani"
                        swiper-animate-effect="fadeInUp"
                        swiper-animate-duration="0.4s"
                        swiper-animate-delay="0.6s"
                      >
                        灵活用
                      </p>
                      <span
                        class="ani"
                        swiper-animate-effect="fadeInUp"
                        swiper-animate-duration="0.4s"
                        swiper-animate-delay="0.8s"
                        >还机、续期、买断、随您选</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="five">
            <div class="table-box">
              <div class="table-cell">
                <div class="five-content">
                  <p class="five-title">倾听TA们的心声</p>
                  <span class="five-tips">让拥有变得简单</span>
                  <div class="xinsheng">
                    <img
                      class="ani"
                      swiper-animate-effect="fadeIn"
                      swiper-animate-duration="0.3s"
                      swiper-animate-delay="0.4s"
                      src="../../assets/picture/11.png"
                      alt=""
                    />
                    <img
                      class="ani"
                      swiper-animate-effect="fadeIn"
                      swiper-animate-duration="0.3s"
                      swiper-animate-delay="0.4s"
                      src="../../assets/picture/22.png"
                      alt=""
                    />
                    <img
                      class="ani"
                      swiper-animate-effect="fadeIn"
                      swiper-animate-duration="0.3s"
                      swiper-animate-delay="0.4s"
                      src="../../assets/picture/33.png"
                      alt=""
                    />
                  </div>
                  <span
                    class="ani"
                    swiper-animate-effect="fadeIn"
                    swiper-animate-duration="0.3s"
                    swiper-animate-delay="0.4s"
                    >真实用户感受</span
                  >
                  <div class="ganshou">
                    <img
                      class="ani"
                      swiper-animate-effect="fadeIn"
                      swiper-animate-duration="0.3s"
                      swiper-animate-delay="0.4s"
                      src="../../assets/picture/pinglun1.png"
                      alt=""
                    />
                    <img
                      class="ani"
                      swiper-animate-effect="fadeIn"
                      swiper-animate-duration="0.3s"
                      swiper-animate-delay="0.4s"
                      src="../../assets/picture/pinglun2.png"
                      alt=""
                    />
                    <img
                      class="ani"
                      swiper-animate-effect="fadeIn"
                      swiper-animate-duration="0.3s"
                      swiper-animate-delay="0.4s"
                      src="../../assets/picture/pinglun3.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="bottomone">
        <!-- <a href="https://beian.miit.gov.cn" target="_blank">
          <span style="color: #fff"> 沪ICP备2024073721号-1 </span>
        </a> -->
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script >
// import { assets } from "../../assets/js/swiper-3.4.2.min.js";
export default {
  name: "",
  data() {
    return {
      num: 1,
      active: "1",
      dialogVisible: false,
      yanzm: "获取验证码",
      seconds: 61,
      peisss: true,
      cheng: false,
      zhuqi: true,
      form: "",
      formm: "",
      list: [],
    };
  },
  // 钩子函数：页面加载完成后执行
};
</script>

<style>
@import url("../../assets/css/about.css");
@import url("../../assets/css/1.css");
@import url("../../assets/css/2.css");
@import url("../../assets/css/3.css");
@import url("../../assets/css/4.css");
@import url("../../assets/css/5.css");
@import url("../../assets/css/6.css");
@import url("../../assets/css/7.css");
@import url("../../assets/css/8.css");
@import url("../../assets/css/9.css");
@import url("../../assets/css/10.css");
@import url("../../assets/css/11.css");
@import url("../../assets/css/12.css");

.top-nav {
  background-color: RGB(237, 237, 249);
}
.swiper-slide {
  height: 1100px !important;
}
.bottomone {
  height: 100px;
  background-color: #000;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 19px;
  font-weight: bold;
}
.header {
  background-color: RGB(237, 237, 249);
}
.activesss {
  background-color: #e84534;
  color: #ffffff;
}
</style>